import { render } from "./PenToolIcon.vue?vue&type=template&id=71e5c41e"
import script from "./PenToolIcon.vue?vue&type=script&lang=js"
export * from "./PenToolIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__